// ═══════════════════════════════════════════════════════════════
// AndroidSignupBlocked.jsx — shown to new users attempting to sign
// up inside the Android TWA. The "Open in Browser" CTA is permitted
// under anti-steering because this IS the signup flow Google
// expects on a web-billing app (the Netflix/Spotify pattern).
// Existing users can still log in normally via the login tab.
// ═══════════════════════════════════════════════════════════════

import React from 'react';
import { Globe, ArrowRight, LogIn } from 'lucide-react';

const WEB_SIGNUP_URL = 'https://app.theargumentor.com/?signup=1&src=android-twa';

function AndroidSignupBlocked({ onSwitchToLogin }) {
  return (
    <div className="text-center">
      <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
        <Globe className="w-8 h-8 text-amber-700" />
      </div>
      <h2 className="text-xl font-semibold text-stone-800 mb-2">
        Sign up at theargumentor.com
      </h2>
      <p className="text-sm text-stone-600 mb-6">
        New accounts are created on the web. Once you finish signing up, return here and you'll be signed in automatically.
      </p>
      <a
        href={WEB_SIGNUP_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center gap-2 w-full py-3 bg-amber-500 hover:bg-amber-600 text-stone-900 rounded-lg font-medium transition-colors mb-3"
      >
        Open in Browser
        <ArrowRight className="w-4 h-4" />
      </a>
      {onSwitchToLogin && (
        <button
          onClick={onSwitchToLogin}
          className="inline-flex items-center justify-center gap-2 w-full py-2.5 bg-stone-100 hover:bg-stone-200 text-stone-700 rounded-lg text-sm font-medium transition-colors"
        >
          <LogIn className="w-4 h-4" />
          I already have an account. Log in
        </button>
      )}
      <p className="text-xs text-stone-500 mt-6">
        Already signed up on the web? Use the Log In tab above with the same email and password.
      </p>
    </div>
  );
}

export default AndroidSignupBlocked;
